import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import { Main } from "./Components/Pages/main.js";
import { Header } from "./Components/header";
import { Footer } from "./Components/footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
